/**
 * @generated SignedSource<<655d81ece952fe65e258e9028cd8a1e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_nativeIssueTable_NativeIssueTable_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_view" | "main_issueTableColumnPicker_ColumnConfig_view">;
  readonly " $fragmentType": "ui_nativeIssueTable_NativeIssueTable_view";
};
export type ui_nativeIssueTable_NativeIssueTable_view$key = {
  readonly " $data"?: ui_nativeIssueTable_NativeIssueTable_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_nativeIssueTable_NativeIssueTable_view",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueTableColumnPicker_ColumnConfig_view"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueTable_nativeIssueTable_view"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "467890bbe52fd2a978a7ca9974a354c1";

export default node;
